
/* tslint:disable */

declare const msCrypto;

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
	(typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
	// WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

	rng = function whatwgRNG() {
		getRandomValues(rnds8);
		return rnds8;
	};
} else {
	// Math.random()-based (RNG)
	//
	// If all else fails, use Math.random().  It's fast, but is of unspecified
	// quality.
	var rnds = new Array(16);

	rng = function mathRNG() {
		for (var i = 0, r; i < 16; i++) {
			if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
			rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
		}

		return rnds;
	};
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
	byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset = 0) {
	var i = offset;
	var bth = byteToHex;
	return bth[buf[i++]] + bth[buf[i++]] +
		bth[buf[i++]] + bth[buf[i++]] + '-' +
		bth[buf[i++]] + bth[buf[i++]] + '-' +
		bth[buf[i++]] + bth[buf[i++]] + '-' +
		bth[buf[i++]] + bth[buf[i++]] + '-' +
		bth[buf[i++]] + bth[buf[i++]] +
		bth[buf[i++]] + bth[buf[i++]] +
		bth[buf[i++]] + bth[buf[i++]];
}

export function getUUIDV4(options?, buf?, offset?) {
	var i = buf && offset || 0;

	if (typeof(options) == 'string') {
		buf = options === 'binary' ? new Array(16) : null;
		options = null;
	}
	options = options || {};

	var rnds = options.random || (options.rng || rng)();

	// Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	rnds[6] = (rnds[6] & 0x0f) | 0x40;
	rnds[8] = (rnds[8] & 0x3f) | 0x80;

	// Copy bytes to buffer, if provided
	if (buf) {
		for (var ii = 0; ii < 16; ++ii) {
			buf[i + ii] = rnds[ii];
		}
	}

	return buf || bytesToUuid(rnds);
}
